
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const all = document.querySelectorAll("*");
    for (const el of all) {
      if (el.scrollTop > 0) {
        el.scrollTop = 0;
        break;
      }
    }
  }, [pathname]);

  return null;
}
